// extracted by mini-css-extract-plugin
export var header = "styles-module--header--frwm7";
export var headerWrapper = "styles-module--header-wrapper--7Cpex";
export var headerLinks = "styles-module--header-links--8ISZT";
export var headerSocialLinks = "styles-module--header-social-links--LWn6-";
export var headerLogo = "styles-module--header-logo--qVOfz";
export var headerNav = "styles-module--header-nav--CAfdg";
export var headerNavLink = "styles-module--header-nav-link--0GoFL";
export var headerNavButton = "styles-module--header-nav-button--og1GO";
export var open = "styles-module--open--7Ck4T";